import Video from '@/data/Video';

export default class Videos {

  private _total: number;
  private _videos = new Array<Video|undefined>();
  
  constructor(total: number) {
    this._total = total;
  } 
  public get total() {
    return this._total;
  }
  public set total(value) {
    this._total = value;
  }
  public get videos() {
    return this._videos;
  }
  public set videos(value) {
    this._videos = value;
  }

  public initFrom(videos: Videos) {
    this.total = videos.total;
    this.videos = videos.videos;
  }

  public clearVideos() {
    for(let i = 0; i < this.videos.length; ++i) {
      this._videos[i] = undefined;
    }
  }

  public clear() {
    this._total = 0;
    this._videos = [];
  }  

  public applyFrom(videos: Videos) {
    if(this._total !== videos.total || this.videos.length !== videos.videos.length) {
      //Logger.warn(`New count of videos ${videos.total} does not macht current count ${this.total}`);
      this.initFrom(videos);
      return;
    }

    const videosTemp: Array<Video|undefined> = [];
    videosTemp.length = videos.total;
    for(let i = 0; i < videos.videos.length; ++i) {
      if(videos.videos[i]) {
        videosTemp[i] = videos.videos[i];
      }
      else {
        videosTemp[i] = this.videos[i];
      }
    }
    this.videos = videosTemp;
  }
}